"use client"

import { create } from "zustand"
import type { AnnouncementStore } from "./types"

/**
 * Internal Zustand store for feature announcement UI state
 *
 * IMPORTANT: Do not use this directly! Use useFeatureAnnouncement() hook instead.
 *
 * No persist middleware - state resets on page reload (intentional).
 * Modal and sidebar are mutually exclusive.
 */
export const useAnnouncementStore = create<AnnouncementStore>()((set) => ({
  isModalOpen: false,
  isSidebarOpen: false,
  isCapturingScreen: false,
  hasSeenAnnouncement: false,
  isGlobalDismissed: false,
  topBarConfig: null,
  feedbackKeyOverride: null,
  feedbackInitialComment: null,
  isChatHistoryOpen: false,
  chatHistoryWidth: 0,

  openModal: () => set({ isModalOpen: true, isSidebarOpen: false, hasSeenAnnouncement: true }),
  closeModal: () => set({ isModalOpen: false }),

  openSidebar: (featureKey, initialComment) =>
    set({
      isSidebarOpen: true,
      isModalOpen: false,
      feedbackKeyOverride: featureKey ?? null,
      feedbackInitialComment: initialComment ?? null,
    }),
  closeSidebar: () =>
    set({
      isSidebarOpen: false,
      feedbackKeyOverride: null,
      feedbackInitialComment: null,
    }),

  setCapturingScreen: (capturing) => set({ isCapturingScreen: capturing }),
  setTopBarConfig: (config) => set({ topBarConfig: config }),
  markAnnouncementSeen: () => set({ hasSeenAnnouncement: true }),
  dismissGlobal: () => set({ isGlobalDismissed: true }),
  setChatHistoryOpen: (open) => set({ isChatHistoryOpen: open }),
  setChatHistoryWidth: (width) => set({ chatHistoryWidth: width }),
}))
